import React from "react";

const Tag = ({ children, onClick, active, tagType }) => {
	return (
		<div
			className={`tag ${tagType || ""} ${active ? "tag-tab-active" : ""}`}
			onClick={onClick}
		>
			{children}
		</div>
	);
};

export default Tag;
